import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

const HtmlEncoderTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [mode, setMode] = useState('encode');

  const htmlEntities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };

  const reverseEntities = Object.fromEntries(
    Object.entries(htmlEntities).map(([k, v]) => [v, k])
  );

  const encode = () => {
    if (!input.trim()) {
      toast.error('Please enter text to encode');
      return;
    }
    const encoded = input.replace(/[&<>"']/g, char => htmlEntities[char]);
    setOutput(encoded);
    toast.success('Encoded!');
  };

  const decode = () => {
    if (!input.trim()) {
      toast.error('Please enter text to decode');
      return;
    }
    let decoded = input;
    Object.entries(reverseEntities).forEach(([entity, char]) => {
      decoded = decoded.split(entity).join(char);
    });
    // Handle numeric entities
    decoded = decoded.replace(/&#(\d+);/g, (_, code) => String.fromCharCode(code));
    decoded = decoded.replace(/&#x([0-9a-f]+);/gi, (_, code) => String.fromCharCode(parseInt(code, 16)));
    setOutput(decoded);
    toast.success('Decoded!');
  };

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied!');
    }
  };

  return (
    <div className="space-y-4" data-testid="html-encoder-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">HTML Encoder/Decoder</h3>
      </div>

      <Tabs value={mode} onValueChange={setMode}>
        <TabsList className="w-full">
          <TabsTrigger value="encode" className="flex-1">Encode</TabsTrigger>
          <TabsTrigger value="decode" className="flex-1">Decode</TabsTrigger>
        </TabsList>
      </Tabs>

      <Textarea
        placeholder={mode === 'encode' ? 'Enter HTML to encode...' : 'Enter encoded HTML to decode...'}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="min-h-[120px] bg-background/50 font-mono text-sm"
        data-testid="input"
      />

      <Button onClick={mode === 'encode' ? encode : decode} className="w-full" data-testid="convert-btn">
        {mode === 'encode' ? 'Encode HTML' : 'Decode HTML'}
      </Button>

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Output</span>
            <Button variant="ghost" size="sm" onClick={copyOutput}>
              <Copy className="w-4 h-4 mr-1" /> Copy
            </Button>
          </div>
          <Textarea
            value={output}
            readOnly
            className="min-h-[120px] bg-background/50 font-mono text-sm"
            data-testid="output"
          />
        </div>
      )}
    </div>
  );
};

export default HtmlEncoderTool;
